import Env from "../base/env";
import Component from "gia/Component";
import { TextHoverSlide } from "./Common";
import gsap from "gsap";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    if (Env.mobileCSS == false) {
      gsap.delayedCall(0.1, () => TextHoverSlide(this.DOM.view));
    }
  }
}
